import { SubscriptionModelsUtilService } from '../../../core/services/ib-subscription-models-utils-service';
import { RedirectionLandingService } from '../../../core/services/ib-subscription-models-redirection-service';
import { SubscriptionModelsConfigurationService } from '../../services/ib-subscription-models-configuration/ib-subscription-models-configuration-service';
import * as angular from 'angular';
import { Pattern } from 'copy-webpack-plugin';
import { Form } from '@angular/forms';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
import { IbCNewPaymentAvailiabilityService } from 'ib-web-commons/dist/http-services';
import { RealmEnum } from 'ib-web-commons/models';
import { Types } from '@src/app/core/models/configuration.model';
const componentOptions = {
    bindings: {
        model: '=',
        importSelected: '=',
        containerForm: '='
    },
    controllerAs : 'subscriptionModelsConfigurationFormCtrl',
    templateUrl: ['SubscriptionModelsAppConstants', (SubscriptionModelsAppConstants: SubscriptionModelsAppConstant): string => `${SubscriptionModelsAppConstants.templatesRoute}ib-subscription-models-configuration-form-view.html`]
};
const componentInfo = {
    module: 'ib-subscription-models-configuration-form-module',
    selector: 'ibSubscriptionModelsConfigurationForm',
    inject:['$scope', '$window',
        'SubscriptionModelsAppConstants',  'SubscriptionModelsConfigurationService',
        'CommonsModalService',  'RedirectionLandingService', 'SubscriptionModelsUtilService',
        'DatalayerUtilsService', '$location', '$timeout', 'CommonsSessionStorageService', 'IbCNewPaymentAvailiabilityService'],
    required: []
};
class ibSubscriptionModelsConfigurationForm implements ng.IController {
    public model: Types.ConfigurationModel;
    public importSelected: Types.FixedPrice;
    public importInfo: Types.importInfo;
    public destination: Types.OriginDestination;
    public origin: Types.OriginDestination;
    public searchModel:Types.searchModel;
    public availabilityResponseModel: Types.AvailabilitySubscriptionModelsResponse;
    public form: any;
    public containerForm;
    public dynamicprice: string;
    public importError: boolean;
    public show: Types.show;
    public frequencyList: any = [];
    public campaign: string;
    public checkFrequentCompanion: boolean = false;
    private formErrors: Types.formErrors;
    private EMAIL_PATTERN: Pattern;
    private NAME_PATTERN: Pattern;
    private NAME_PATTERN_CLEANER: Pattern;

    constructor (private $scope: angular.IScope, private $window: ng.IWindowService,
        private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant, private SubscriptionModelsConfigurationService: SubscriptionModelsConfigurationService,
        private CommonsModalService: CommonsModalService, private RedirectionLandingService: RedirectionLandingService, private SubscriptionModelsUtilService: SubscriptionModelsUtilService,
        private DatalayerUtilsService:DatalayerUtilsService, private $location: ng.ILocationService, private $timeout: ng.ITimeoutService, private CommonsSessionStorageService: CommonsSessionStorageService,
        private IbCNewPaymentAvailiabilityService: IbCNewPaymentAvailiabilityService
    ) {
        this.importError = false;
        this.dynamicprice = '';
        this.$scope.$on('citySelectorType', this.updateCityAndDestiny);
        this.EMAIL_PATTERN = SubscriptionModelsAppConstants.PATTERNS.EMAIL_PATTERN;
        this.NAME_PATTERN = SubscriptionModelsAppConstants.PATTERNS.NAME_SURNAME_PATTERN;
        this.NAME_PATTERN_CLEANER = SubscriptionModelsAppConstants.PATTERNS.NAME_SURNAME_CLEANER;

    }

    $onInit () {
        this.show = this.SubscriptionModelsConfigurationService.initShow();
        this.initFormErrors();
        const redirectionPaymentCallback: any = this.CommonsSessionStorageService.get('redirectionPaymentCallback');
        if(!redirectionPaymentCallback) {
            this.$timeout(() => {this.getOrigin();}, 2000);
        }
    }
    getOrigin () {
        this.SubscriptionModelsConfigurationService.getOriginsDestinations('origin').then((response) => {
            this.origin = response;
        }, (error) => {

        });
    }
    initFormErrors = () => {
        this.formErrors = {
            importError: false,
            nameError: false,
            surnameError :false,
            emailError : false,
            emailFormatError: false,
            nameCompanionError : false,
            surnameCompanionError : false,
            emailCompanionError : false,
            emailCompanionFormatError: false
        };
    };
    changeFrequency = () => {
        if(!this.show.showImportButton) {
            this.show.showRecalculateButton = true;
        }
        this.ImportFlow();
    };

    checkType = (originInput): boolean => {
        return typeof originInput === 'object';
    };


    updateFrequencyList = (cityDestiny): void => {
        let frequencyModel = {id: 0, name: ''};
        this.frequencyList = [];
        this.model.body.frequency = frequencyModel;

        for (var i:number = cityDestiny.minFrequency; i <= cityDestiny.maxFrequency; i++) {
            let frequencyTemp = {...frequencyModel};
            frequencyTemp.id = i;
            frequencyTemp.name = i.toString();
            this.frequencyList.push(frequencyTemp);
        }
    };

    resetFrequencyList = (): void => {
        let frequencyModel = {id: 0, name: ''};
        this.frequencyList = [];
        this.model.body.frequency = frequencyModel;

        this.frequencyList.push(frequencyModel);
    };

    updateCityAndDestiny = (event: angular.IAngularEvent, type: string) => {
        this.$timeout(() => {
            if (type === this.SubscriptionModelsAppConstants.TYPE_CITY.ORIGIN) {
                this.model.body.origin = this.searchModel.cityOrigin;
                this.SubscriptionModelsConfigurationService.getOriginsDestinations('destination', this.searchModel.cityOrigin.code).then((response) => {
                    this.destination = response;
                    this.model.body.destination = null;
                    this.searchModel.cityDestiny = null;
                    this.resetFrequencyList();

                });

            } else {
                this.model.body.destination = this.searchModel.cityDestiny;
                this.updateFrequencyList(this.searchModel.cityDestiny);
                if(!this.show.showImportButton) {
                    this.ImportFlow();
                }

            }

            this.show.showImport = false;
            // if(!this.show.showImportButton) {
            //     this.show.showRecalculateButton = true;
            // }
        });
    };
    conditionFilter = (importSelected, campaigns) => {
        let campaignSelected;
        campaigns.forEach(campaign => {
            if (importSelected && (campaign.campaignId === importSelected.campaignId)) {
                campaignSelected = campaign;
                campaignSelected.discount = importSelected.discount;
            }
        });
        return campaignSelected;
    };

    changeCheckCompanion = () => {
        this.model.body.accompanyingPassenger = {
            name: '',
            surname: '',
            email: ''
        };
    };

    checkImportForm = (): boolean=> {
        let importError = false;
        if (!this.importSelected) {
            this.importError = true;
            this.formErrors.importError = this.importError;
        }else {
            this.importError = false;
            this.formErrors.importError = this.importError;
        }
        return importError;
    };
    completeForm = () :void => {
        let isError = this.checkImportForm();
        this.form.$submitted = true;
        const template :string = 'ib-modal-subscription-models-conditions.html';

        if (this.form.$valid && !isError) {
            let campaignSelected = this.conditionFilter(this.importSelected, this.importInfo.campaigns);
            this.model.body.amount = this.importSelected.amount;
            const info = this.SubscriptionModelsConfigurationService.getModelConditions(campaignSelected, this.model);
            this.CommonsModalService.openBuildGenericModal(
                info,
                template,
                'ib-modals--large',
                'ibModalConditionsController'
            ).result.then(():void =>{
                this.goToPayment();
            }, ():void =>{
            });
        }
    };

    goToPayment = ():void =>{
        this.CommonsSessionStorageService.set('subscriptionModelsConfigurationInfo', this.model);
        this.SubscriptionModelsConfigurationService.putSubscriptionModels(
            this.SubscriptionModelsConfigurationService.transformData(this.model, this.importSelected.campaignId, this.checkFrequentCompanion)
        ).then(async (data) => {
            this.CommonsSessionStorageService.set('subscriptionModelsFlowId', this.model.body.flowId);
            const isNewPaymentAvailiability = await this.IbCNewPaymentAvailiabilityService.isNewPaymentAvailiability(RealmEnum.SUBSCRIPTION);
            const paymentsURI = isNewPaymentAvailiability ? this.SubscriptionModelsAppConstants.PAGES_ROUTES.NEW_PAYMENTS : this.SubscriptionModelsAppConstants.PAGES_ROUTES.PAYMENTS;
            this.$location.path(paymentsURI);
        },
        (error)=>{
            this.CommonsModalService.showGenericError(error, false, null).result.then(angular.noop, angular.noop);
        });

    };

    cancel = () :void=>{
        this.CommonsModalService.showGenericModal(true, 'ib-modal-back-subscription-models.html',
            { idModal: this.SubscriptionModelsAppConstants.GIFT_CARDS_BACK }, null).result.then( () => {
            this.RedirectionLandingService.redirection(this.SubscriptionModelsAppConstants.market.toLowerCase(), this.SubscriptionModelsAppConstants.lang.toUpperCase());
        }, angular.noop);

    };
    ImportFlow = () => {

        const modelTemp = this.model;

        const getAvailabilityModel = this.SubscriptionModelsConfigurationService.generateGetAvailabilityModel(this.model);
        this.SubscriptionModelsConfigurationService.getAvailability(getAvailabilityModel).then((data) => {

            modelTemp.body.currency = data.currency;
            this.model.body.flowId = data.flowId;

            this.importInfo = data;

            this.show.showImport = true;
            this.show.showImportButton = false;
        });
        this.importSelected = null;
        this.dynamicprice = '';
    };


}
try {
    const mod = angular.module(componentInfo.module);
    ibSubscriptionModelsConfigurationForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsConfigurationForm })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibSubscriptionModelsConfigurationForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSubscriptionModelsConfigurationForm })
    );
}
